import styled from 'styled-components'

export const ContentBlockList = styled.ul.attrs(props => ({
    width: props.fullWidth ? '100%' : 'calc(50% - 0.5rem)',
}))`
    display: flex;
    flex-flow: row wrap;
    list-style-type: none;
    justify-content: space-between;
    padding: 0;

    li {
        flex-basis: ${props => props.width};
        margin-bottom: 1rem;
    }

    .content-editor__block {
        display: flex;
        flex-direction: column;
        height: 100%;
        border: 1px solid rgba(0, 0, 0, 0.1);
        transition: background-color 0.2s linear;
        cursor: move;
        cursor: grab;
        cursor: -moz-grab;
        cursor: -webkit-grab;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        &:hover {
            background-color: #444444;
        }

        &:active {
            cursor: grabbing;
            cursor: -moz-grabbing;
            cursor: -webkit-grabbing;
        }
    }

    .content-editor__block--icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
    }

    .content-editor__block--name {
        background-color: #666;
        padding: 2px 5px;
        color: #fff;
        font-weight: 500;
    }
`
